import ApiService from '@/core/services/api.service';
import { makeToastSuccess, handleError } from '@/utils/common';

export const createDealSheet = async (payload) => {
  try {
    const response = await ApiService.post('v1/deal-sheets', payload);
    const message = response.data?.message;
    makeToastSuccess(message);
    return response.data.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

export const updateDealSheet = async (id, payload) => {
  try {
    const response = await ApiService.put(`v1/deal-sheets/${id}`, payload);
    const { message } = response.data;

    makeToastSuccess(message);
    return response.data.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

export const getDealSheetById = async (id) => {
  try {
    const response = await ApiService.get(`v1/deal-sheets/${id}`);
    return response.data.data;
  } catch (err) {
    handleError(err);
  }
};

export const getDealSheetByIdForPurchaseOrder = async (id) => {
  try {
    const response = await ApiService.get(`v1/deal-sheets/${id}/for-purchase-order`);
    return response.data.data;
  } catch (err) {
    handleError(err);
  }
};

export const getDealSheets = async (params) => {
  try {
    const response = await ApiService.query('v1/deal-sheets', { params });
    return response.data.data;
  } catch (err) {
    handleError(err);
    return { dataset: [], totalRow: 0, totalPage: 1 };
  }
};

export const getDealSheetsForSelect = async (params) => {
  try {
    const response = await ApiService.query('v1/deal-sheets/select', { params });
    return response.data.data;
  } catch (err) {
    handleError(err);
    return { dataset: [], totalRow: 0, totalPage: 1 };
  }
};

export const getDealSheetsExpire = async () => {
  try {
    const response = await ApiService.get('v1/deal-sheets/expire');
    return response.data.data || [];
  } catch (err) {
    handleError(err);
    return [];
  }
};

export const deleteDealSheet = async (id) => {
  try {
    if (Array.isArray(id)) {
      // Bulk delete
      const promises = id.map((itemId) =>
        ApiService.delete(`v1/deal-sheets/${itemId}`),
      );
      await Promise.all(promises);
      makeToastSuccess('Xóa thành công');
      return true;
    } else {
      const result = await ApiService.delete(`v1/deal-sheets/${id}`);
      const { message } = result.data;
      makeToastSuccess(message);
      return true;
    }
  } catch (err) {
    handleError(err);
    return false;
  }
};
